import React from 'react'
import { useHistory } from 'react-router-dom'
import Brands from '../LandingPage/component/Brands'
import NewAcademy from '../NewHomePage/components/NewAcademy'
import NewTestimonials from '../NewHomePage/components/NewTestimonials'
import BuyersSeo from '../../components/Seo-helmet/service/Buyers'
import BuyerBenefits from './components/BuyerBenefits'
import BuyerImages from './components/BuyerImages'
import NewsLetter from '../about/component/NewsLetter'
import language from '../../helpers/language'
import iconAi from '../../assets/landing-page/icon-ai.png'

const BuyerPage = () => {
  const [lang] = React.useState(language.getLang())
  const history = useHistory()
  const [search, setSearch] = React.useState('')
  const aiAssistantPlaceholders = React.useMemo(
    () => lang?.aiAssistantPlaceholders || ['Discover authentic Italian products'],
    [lang]
  )
  const [placeholderIndex, setPlaceholderIndex] = React.useState(0)
  const [typedPlaceholder, setTypedPlaceholder] = React.useState('')
  const [isDeletingPlaceholder, setIsDeletingPlaceholder] = React.useState(false)

  React.useEffect(() => {
    const currentText = aiAssistantPlaceholders[placeholderIndex] || ''

    if (!isDeletingPlaceholder && typedPlaceholder.length === currentText.length) {
      const pauseTimer = setTimeout(() => setIsDeletingPlaceholder(true), 1200)
      return () => clearTimeout(pauseTimer)
    }

    if (isDeletingPlaceholder && typedPlaceholder.length === 0) {
      setIsDeletingPlaceholder(false)
      setPlaceholderIndex((currentIndex) => (currentIndex + 1) % aiAssistantPlaceholders.length)
      return undefined
    }

    const typeTimer = setTimeout(() => {
      const nextLength = typedPlaceholder.length + (isDeletingPlaceholder ? -1 : 1)
      setTypedPlaceholder(currentText.slice(0, nextLength))
    }, isDeletingPlaceholder ? 24 : 45)

    return () => clearTimeout(typeTimer)
  }, [aiAssistantPlaceholders, isDeletingPlaceholder, placeholderIndex, typedPlaceholder])

  const submitSearch = () => {
    if (search.trim()) {
      history.push('/chat', { initialMessage: search.trim() })
    }
  }

  return (
    <div className="font-sf-pro">
      <BuyersSeo />

      <div
        className="w-full md:px-16 px-6 md:pt-40 pt-32 md:pb-20 pb-14 text-center"
        style={{ backgroundColor: "#004577" }}
      >
        <h1 className="md:text-5xl text-3xl font-extrabold text-white mb-5 leading-tight">
          {lang?.Buyers_page_title}
        </h1>
        <p className="text-white text-base font-normal max-w-2xl mx-auto leading-relaxed">
          {lang?.Buyers_page_description}
        </p>
        {/* <div className="w-full max-w-3xl mx-auto mt-8">
          <p className="text-white text-base font-semibold mb-3">
            Tell us what you are looking for
          </p>
          <p className="text-white text-xs mb-3">
            Describe your sourcing needs and we'll match you with relevant Italian producers.
          </p>

          <div className="bg-white rounded-2xl shadow-2xl p-4 text-left">
            <div className="flex items-center gap-3">
              <div className="flex-1">
                <div className="relative">
                  {!search && (
                    <div className="absolute inset-0 flex items-center pointer-events-none text-sm text-gray-600">
                      <span>{typedPlaceholder}</span>
                    </div>
                  )}
                  <input
                    type="text"
                    placeholder=""
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        submitSearch()
                      }
                    }}
                    className="w-full text-sm text-gray-800 placeholder-gray-400 outline-none bg-transparent relative z-10"
                    style={{ caretColor: 'auto' }}
                  />
                </div>
              </div>
              <button
                type="button"
                onClick={submitSearch}
                className="w-10 h-10 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center transition-colors flex-shrink-0"
                aria-label="Start AI search"
              >
                <i className="fa fa-arrow-up text-sm" />
              </button>
            </div>
            <div className="border-t border-gray-100 mt-3 pt-3 flex items-center gap-2">
              <img src={iconAi} alt="AI Icon" className="w-5 h-5" />
              <span className="text-xs text-gray-500 font-semibold">AI Assistant</span>
            </div>
          </div>

          <p className="text-white text-xs mt-3">
            We'll match you with 3-5 relevant producers!
          </p>
        </div> */}
      </div>

      <Brands />
      <BuyerBenefits />
      <BuyerImages />
      <NewAcademy />
      <NewTestimonials />
      {/* <NewsLetter /> */}
    </div>
  )
}

export default BuyerPage
